"use client";
import React, { useState } from "react";
import ButtonHeadless from "@components/items/display/Button";
import { ScrollArea } from "@ui/scroll-area";
import TranslatedText from "@components/items/display/TranslatedText";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { SVG } from "@components/items/common/SVG";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@ui/accordion";
import { Direction } from "@utils/types/common";

interface GeneralQuestionsProps {
  dir: Direction;
}

const GeneralQuestions = ({ dir }: GeneralQuestionsProps) => {
  return (
    <ScrollArea className="h-[800px] w-full" dir={dir}>
      <HelpCenterAccordion
        data={[
          {
            id: "1",
            trigger: "هل تطبيق وجيز مجاني بالكامل؟",
            content:
              "يمكنك التمتع ببعض المزايا مجانًا في تطبيق وجيز، دون التمتع بمزاياه كافة بالمجان. من المزايا المجانية في وجيز توفيره ملخص كتاب واحد يوميا بالمجان، وهو موجود في أعلى الصفحة الرئيسية في التطبيق. في حال قمت بدعوة أصدقائك إلى التسجيل في التطبيق، أو في حال إتمامك القراءة أو الاستماع للملخصات المجانية اليومية، ستحصل على نقاط تمكنّك من فتح ملخصات الكتب الأخرى المغلقة دون أي مقابل مالي",
            isRated: false,
          },
          {
            id: "2",
            trigger: "كيف يندرج وجيز تحت قائمة التطبيقات المجانية؟",
            content:
              "يمكنك التمتع ببعض المزايا مجانًا في تطبيق وجيز، دون التمتع بمزاياه كافة بالمجان. من المزايا المجانية في وجيز توفيره ملخص كتاب واحد يوميا بالمجان، وهو موجود في أعلى الصفحة الرئيسية في التطبيق. في حال قمت بدعوة أصدقائك إلى التسجيل في التطبيق، أو في حال إتمامك القراءة أو الاستماع للملخصات المجانية اليومية، ستحصل على نقاط تمكنّك من فتح ملخصات الكتب الأخرى المغلقة دون أي مقابل مالي",
            isRated: false,
          },
          {
            id: "3",
            trigger:
              "هل يوفر وجيز ملخصات لكتب الأدب مثل الروايات والشعر والقصة القصيرة؟",
            content:
              "يمكنك التمتع ببعض المزايا مجانًا في تطبيق وجيز، دون التمتع بمزاياه كافة بالمجان. من المزايا المجانية في وجيز توفيره ملخص كتاب واحد يوميا بالمجان، وهو موجود في أعلى الصفحة الرئيسية في التطبيق. في حال قمت بدعوة أصدقائك إلى التسجيل في التطبيق، أو في حال إتمامك القراءة أو الاستماع للملخصات المجانية اليومية، ستحصل على نقاط تمكنّك من فتح ملخصات الكتب الأخرى المغلقة دون أي مقابل مالي",
            isRated: true,
          },
          {
            id: "4",
            trigger: "هل يوفر وجيز كتبا كاملة؟",
            content:
              "يمكنك التمتع ببعض المزايا مجانًا في تطبيق وجيز، دون التمتع بمزاياه كافة بالمجان. من المزايا المجانية في وجيز توفيره ملخص كتاب واحد يوميا بالمجان، وهو موجود في أعلى الصفحة الرئيسية في التطبيق. في حال قمت بدعوة أصدقائك إلى التسجيل في التطبيق، أو في حال إتمامك القراءة أو الاستماع للملخصات المجانية اليومية، ستحصل على نقاط تمكنّك من فتح ملخصات الكتب الأخرى المغلقة دون أي مقابل مالي",
            isRated: true,
          },
        ]}
      />
      <div className="flex flex-col items-center justify-center pb-24">
        <TranslatedText
          text={`help-center.titles.${"you can always contact us directly"}`}
          className="pb-5 text-[24px] font-bold text-black dark:text-white"
        />
        <div className="flex items-center justify-center">
          <ButtonHeadless
            widthStyle="mx-auto"
            paddingYStyle="px-5 py-3"
            action={() =>
              // TODO: Recheck Router
              // router.push('/b2c/contact-us')
              console.log("/b2c/contact-us")
            }
          >
            <TranslatedText
              text={`help-center.buttons.${"contact us"}`}
              className="font-medium text-white"
            />
          </ButtonHeadless>
        </div>
      </div>
    </ScrollArea>
  );
};

export default GeneralQuestions;

interface HelpAccordionProps {
  // collapsible?: boolean;
  data: {
    id: string | number | undefined;
    trigger: React.ReactNode;
    content: React.ReactNode;
    isRated?: boolean;
  }[];
  containerClassName?: string;
  triggerClassName?: string;
  itemClassName?: string;
  contentClassName?: string;
  type?: "single" | "multiple";
}

const RatingSection = ({ isRated }: { isRated: boolean }) => {
  const [rated, setRated] = useState(false);

  return (
    <div
      className={`flex w-full items-center ${
        isRated || rated ? "justify-center" : "justify-between"
      } px-4 pt-6`}
    >
      {isRated || rated ? (
        <TranslatedText
          text={`help-center.titles.${"thanks for your opinion"}`}
        />
      ) : (
        <>
          <TranslatedText
            className="dark:text-white"
            text={`help-center.titles.${"did you find this article useful?"}`}
          />
          <div className="rotate(180deg) flex items-center justify-center gap-[19px]">
            <ShadcnButton
              className="rounded-full bg-primary p-3"
              onClick={() => setRated(true)}
            >
              <SVG src="/assets/icons/thumbs-up.svg" />
            </ShadcnButton>
            <ShadcnButton
              className="rotate-180 rounded-full bg-primary p-3"
              onClick={() => setRated(true)}
            >
              <SVG src="/assets/icons/thumbs-up.svg" />
            </ShadcnButton>
          </div>
        </>
      )}
    </div>
  );
};

export const HelpCenterAccordion = ({
  data,
  // collapsible = true,
  containerClassName,
  itemClassName,
  triggerClassName,
  contentClassName,
  type = "multiple",
}: HelpAccordionProps) => {
  return (
    <Accordion
      type={type}
      // collapsible={collapsible}
      className={`w-full p-12 pb-0 ${containerClassName}`}
    >
      {data?.length > 0 &&
        data.map(({ id, trigger, content, isRated }) => (
          <AccordionItem
            value={id?.toString() || ""}
            key={id}
            className={`my-5 rounded-xl bg-[#D9D9D926]/15 px-8 dark:bg-[#37383F] ${triggerClassName}`}
          >
            <AccordionTrigger
              className={`text-[15px] font-medium dark:text-white ${itemClassName}`}
            >
              {trigger}
            </AccordionTrigger>
            <AccordionContent
              className={`pe-8 text-[15px] dark:text-white ${contentClassName}`}
            >
              <div className="ltr:text-left rtl:text-right">{content}</div>
            </AccordionContent>
          </AccordionItem>
        ))}
    </Accordion>
  );
};
